import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { useBooking } from '../context/BookingContext';
import { CalendarHeart } from 'lucide-react';

const BookingModal = () => {
  const { open, url, title, closeBooking } = useBooking();
  const embedUrl = url.includes('?') ? `${url}&embed=true` : `${url}?embed=true`;

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) closeBooking(); }}>
      <DialogContent className="max-w-3xl w-[94vw] p-0 overflow-hidden border-none bg-[#FBFAF8] gap-0">
        <DialogHeader className="px-6 pt-6 pb-4 bg-[#43265E] text-white">
          <DialogTitle className="font-display text-2xl font-medium flex items-center gap-3">
            <CalendarHeart className="w-5 h-5 text-[#D9CEE6]" strokeWidth={1.5} />
            {title}
          </DialogTitle>
          <p className="text-[#D9CEE6] text-sm font-light tracking-luxe">Select a time — TAG us in.</p>
        </DialogHeader>
        <div className="h-[70vh] bg-white">
          <iframe
            title="Booking calendar"
            src={embedUrl}
            className="w-full h-full border-0"
            frameBorder="0"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BookingModal;
